<template>
  <div id="navigation">

  </div>
</template>

<script>
export default {
  name: 'navigation'
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?0255e044